import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home, BookOpen, Download, ArrowRight } from "lucide-react";
import SEO from "@/components/common/SEO";
import Stamp from "@/components/common/Stamp";

export default function NotFound() {
    return (
        <>
            <SEO
                title="404 · Expediente extraviado · El Mapa Inverso"
                description="Esta página no existe. Volvé al inicio, descargá el libro gratis o explorá la bio del autor."
                path="/404"
                noindex={true}
            />
            <section className="min-h-[70vh] flex items-center py-20 grain" data-testid="not-found-page">
                <div className="container-x text-center max-w-3xl mx-auto">
                    <div className="mb-8 inline-block">
                        <Stamp size="lg" rotation={-8}>
                            404 · Sin retorno
                        </Stamp>
                    </div>
                    <h1 className="font-display text-6xl md:text-8xl leading-[0.85] mb-6">
                        Expediente{" "}
                        <span className="text-[var(--danger)]">extraviado</span>
                    </h1>
                    <p className="font-mono text-base md:text-lg text-[var(--paper)] mb-3">
                        Esta página no existe en nuestro archivo.
                    </p>
                    <p className="font-hand text-2xl text-[var(--warning)] -rotate-1 inline-block mb-14">
                        Otra promesa rota del catálogo.
                    </p>

                    {/* Accesos recomendados */}
                    <div className="grid sm:grid-cols-3 gap-4 mb-10 text-left">
                        <Link
                            to="/"
                            className="border border-[var(--line)] hover:border-[var(--warning)] p-5 bg-[#0d0d0d] block group"
                            data-testid="404-home"
                        >
                            <Home className="w-5 h-5 text-[var(--warning)] mb-3" />
                            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-muted)] mb-1">
                                01
                            </p>
                            <p className="font-display text-xl text-[var(--paper-2)] group-hover:text-[var(--warning)]">
                                Inicio
                            </p>
                            <p className="font-mono text-xs text-[var(--ink-muted)] mt-1">
                                Volver al home del proyecto.
                            </p>
                        </Link>
                        <Link
                            to="/libro"
                            className="border border-[var(--line)] hover:border-[var(--warning)] p-5 bg-[#0d0d0d] block group"
                            data-testid="404-libro"
                        >
                            <BookOpen className="w-5 h-5 text-[var(--warning)] mb-3" />
                            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-muted)] mb-1">
                                02
                            </p>
                            <p className="font-display text-xl text-[var(--paper-2)] group-hover:text-[var(--warning)]">
                                El libro
                            </p>
                            <p className="font-mono text-xs text-[var(--ink-muted)] mt-1">
                                Ficha, capítulos y contratapa.
                            </p>
                        </Link>
                        <Link
                            to="/descargar"
                            className="border-2 border-[var(--danger)] hover:border-[var(--warning)] p-5 bg-[#0d0d0d] block group"
                            data-testid="404-descargar"
                        >
                            <Download className="w-5 h-5 text-[var(--danger)] mb-3" />
                            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--danger)] mb-1">
                                03 · 100% gratis
                            </p>
                            <p className="font-display text-xl text-[var(--paper-2)] group-hover:text-[var(--warning)]">
                                Descargar
                            </p>
                            <p className="font-mono text-xs text-[var(--ink-muted)] mt-1">
                                PDF + EPUB al instante.
                            </p>
                        </Link>
                    </div>

                    <div className="border-t border-dashed border-[var(--ink-dim)] pt-6">
                        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-muted)] mb-3">
                            O explorá el ecosistema
                        </p>
                        <div className="flex flex-wrap gap-x-5 gap-y-2 justify-center font-mono text-xs">
                            <Link
                                to="/nelson-gonzalez-rodriguez"
                                className="text-[var(--paper-2)] hover:text-[var(--warning)] inline-flex items-center gap-1"
                            >
                                Acerca de Nelson
                                <ArrowRight className="w-3 h-3" />
                            </Link>
                            <Link
                                to="/libros-de-adicciones"
                                className="text-[var(--paper-2)] hover:text-[var(--warning)] inline-flex items-center gap-1"
                            >
                                Libros de adicciones
                                <ArrowRight className="w-3 h-3" />
                            </Link>
                            <Link
                                to="/cuentos-para-adictos"
                                className="text-[var(--paper-2)] hover:text-[var(--warning)] inline-flex items-center gap-1"
                            >
                                Cuentos para adictos
                                <ArrowRight className="w-3 h-3" />
                            </Link>
                            <Link
                                to="/salida"
                                className="text-[var(--danger)] hover:text-[var(--paper-2)] inline-flex items-center gap-1"
                            >
                                Salida de emergencia
                                <ArrowRight className="w-3 h-3" />
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
